import React, { Fragment } from "react";
import PropTypes from "prop-types";

const OrLineDivider = ({ key }) => {
	return (
		<Fragment key={`${key}-separator`}>
			<br />
			<div className="col-md-12" style={{ display: "flex" }}>
				<hr style={{ width: "35%", display: "inline-block" }} />
				<p
					className="body text-muted"
					style={{
						width: "30%",
						textAlign: "center",
						display: "inline-block",
						margin: "auto",
					}}
				>
					Or
				</p>
				<hr style={{ width: "35%", display: "inline-block" }} />
			</div>
			<br />
		</Fragment>
	);
};

OrLineDivider.propTypes = {
	key: PropTypes.string,
};

OrLineDivider.defaultProps = {
	key: "or-line-divider",
};

export default OrLineDivider;
